import { render } from "./AdapterComponent.vue?vue&type=template&id=cabb25d2&scoped=true"
import script from "./AdapterComponent.vue?vue&type=script&lang=js"
export * from "./AdapterComponent.vue?vue&type=script&lang=js"

import "./AdapterComponent.vue?vue&type=style&index=0&id=cabb25d2&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cabb25d2"]])

export default __exports__